import * as yup from 'yup'

export const baseInput = yup.object({
	name: yup.string(),
	formGroup: yup.string(),
})
